import {Component, EventEmitter, Input, Output, OnInit} from 'ng-metadata/core';

import './keywords.scss';

/**
 * @ngdoc directive
 * @name mwContentDocumentKeywords
 * @module mw.components.contentDocuments
 *
 * @param {array} [keywords] - The array of keywords. Can be an array of strings or an array of objects.  If it is an array of objects, you need to set the 'keywords-display-prop' property
 * @param {string} [keywords-display-prop] - The property name in the keyword object that should be used for display
 * @param {boolean} [is-keywords-clickable=false] - Control if keywords are clickable (if true, shows keywords as clickable on hover and will invoke on-keyword-click expression on click).
 * @param {expression} [on-keyword-click] - A function that will be passed in which will be invoked when you when you click on a keyword
 * @param {number} [truncate-limit=null] - number of keywords to show before truncation, if null, keywords are not truncated
 * @param {boolean} [truncate-is-collapsible=true] - boolean to allow collapsing keywords when they are expanded
 * @param {string} [truncate-expand-text='See all'] - text displayed on instead of default
 * @param {string} [truncate-collapse-text='See less'] - text displayed on instead of default
 *
 * @description
 * `<mw-content-document-keywords> is a component that renders an array of keywords to use for your component`
 * @usage
 * <hljs hljs-languge="html">
 *  <mw-content-document-keywords keywords="{{['key', 'word']}}"> </mw-content-document-keywords>
 * </hljs>
 */
@Component({
    selector: 'mw-content-document-keywords',
    template: `
        <div ng-if="::$ctrl.keywords.length > 0" class="mw-content-document-keywords"
            ng-class="{'mw-content-document-keywords--truncated': !$ctrl.showAll, 'mw-content-document-keywords--clickable': $ctrl.isKeywordsClickable}">
            <span ng-repeat="keyword in ::$ctrl.keywords track by $index"
                ng-class="::{'mw-content-document-keywords__keyword--hideable': ($index > $ctrl.truncateLimit - 1) }"><!--
             --><span class="mw-content-document-keywords__keyword-separator" ng-if="::!$first">, </span><!--
             --><span ng-click="$ctrl.handleKeywordClick(keyword)"
                    class="mw-content-document-keywords__keyword"
                    >{{$ctrl.keywordsDisplayProp ? keyword[$ctrl.keywordsDisplayProp] : keyword}}</span><!--
         --></span><!--
         --><span class="mw-content-document-keywords__truncate-toggle-wrapper" ng-if="::$ctrl.truncateLimit && $ctrl.keywords.length > $ctrl.truncateLimit"><!--
                --><span class="mw-content-document-keywords__ellipsis">...</span>
                <a class="mw-content-document-keywords__truncate-toggle mw-content-document-keywords__truncate-toggle-expand"
                    ng-click="$ctrl.toggleTruncation()"
                    translate="{{$ctrl.truncateExpandText}}">
                </a>
                <a class="mw-content-document-keywords__truncate-toggle mw-content-document-keywords__truncate-toggle-collapse"
                    ng-if="::$ctrl.truncateIsCollapsible"
                    ng-click="$ctrl.toggleTruncation()"
                    translate="{{$ctrl.truncateCollapseText}}">
                </a>
            <span>
        </div>
    `
})

export class KeywordsComponent implements OnInit {
    @Input('<') keywords: Array<string>;
    @Input('@') keywordsDisplayProp: string;

    @Input('<') isKeywordsClickable: boolean;
    @Input('<') truncateLimit: number = 5;
    @Input('<') truncateIsCollapsible: boolean;
    @Input('@') truncateExpandText = 'mw-content-document-keywords--expand';
    @Input('@') truncateCollapseText = 'mw-content-document-keywords--collapse';

    @Output() onKeywordClick = new EventEmitter<string>();

    private showAll = false;

    constructor() {}

    ngOnInit() {
        this.isKeywordsClickable = this.isKeywordsClickable ? true : false;
        this.truncateIsCollapsible = this.truncateIsCollapsible === false ? false : true;
    }

    handleKeywordClick(keyword: string) {
        if (this.isKeywordsClickable) {
            this.onKeywordClick.emit(keyword);
        }
    }

    toggleTruncation() {
        this.showAll = !this.showAll;
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/shared/keywords/keywords.component.ts